import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import {
  useDeleteDocumentTypeMutation,
  useFetchGetDocumentTypesQuery,
} from "../../../../store";
import Box from "@mui/material/Box";
import { columns } from "../utils/documentColumns";
import ManagementToolbar from "../../managementShared/ManagementToolbar";
import {
  CONFIRM_DIALOG,
  DOCUMENT_CRUD_DIALOG,
} from "../../../../store/slices/utils/dialogEnum";
import { setDocument } from "../../../../store/slices/applicationManagement/managementSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  closeDialog,
  openDialog,
} from "../../../../store/slices/dialog/dialogSlice";
import DocumentForm from "./DocumentForm";
import CustomConfirmDialog from "../../../../components/shared/CustomConfirmDialog";
import ListHeader from "../../managementShared/ListHeader";
import {
  openErrorToast,
  openSuccessToast,
} from "../../../../store/slices/toast/toastSlice";

const DocumentList = () => {
  const dispatch = useDispatch();
  const { data, isLoading } = useFetchGetDocumentTypesQuery(
    { page: 1, limit: 100 },
    { refetchOnMountOrArgChange: true }
  );
  const { document } = useSelector((state) => state.managementSlice);
  const { documentCRUDDialogOpen } = useSelector((state) => state.dialogSlice);
  const handleUpdate = (document) => {
    dispatch(setDocument(document));
    dispatch(openDialog(DOCUMENT_CRUD_DIALOG));
  };

  const handleDelete = (document) => {
    dispatch(setDocument(document));
    dispatch(openDialog(CONFIRM_DIALOG));
  };

  const closeDelete = () => {
    dispatch(setDocument(null));
    dispatch(closeDialog(CONFIRM_DIALOG));
  };

  const [deleteDocument, { isLoading: deleteDocumentLoading }] =
    useDeleteDocumentTypeMutation();

  const postDelete = () => {
    deleteDocument(document.id).then((res) => {
      if (res) {
        if (!res.data.isSuccess) {
          dispatch(openErrorToast(res.data.message));
        } else {
          dispatch(openSuccessToast("İşlem Tamamlandı"));
          closeDelete();
        }
      }
    });
  };

  return (
    <Box
      sx={{
        height: "auto",
        width: "100%",
        marginTop: 10,
        overflowX: "auto",
        minWidth: { xs: 600, sm: 0 },
        flex: "flex",
        flexDirection: "column",
      }}
    >
      <ListHeader text="Belge Türleri" />
      {document && (
        <CustomConfirmDialog
          handleConfirm={postDelete}
          title="Belge Silme"
          text="Bu belgeyi silmek istediğinize emin misiniz?"
          isLoading={deleteDocumentLoading}
          handleClose={closeDelete}
        />
      )}
      {documentCRUDDialogOpen && <DocumentForm />}
      <DataGrid
        rows={data?.data || []}
        loading={isLoading}
        disableColumnMenu
        columns={columns(handleUpdate, handleDelete)}
        pageSizeOptions={[5, 10, 25, 50]}
        disableRowSelectionOnClick
        slots={{
          toolbar: (props) => (
            <ManagementToolbar {...props} dialogType={DOCUMENT_CRUD_DIALOG} />
          ),
        }}
        showToolbar
      />
    </Box>
  );
};

export default DocumentList;
